import services from '@/services';
import parameters from "@/constants/parameters.js";

export default {
    getVersions: async (user) => {
        const payload = await services.getAsync({
            url: '/versions',
            timeout: 20000,
            hasToken: !!user && !!user.uid,
            refreshToken: true
        });
        if (!!payload.forbiddenAppVersion) {
            return { status: parameters.FORBIDDEN_APP_VERSION, payload };
        } else if (!!payload.hasNewAppVersion) {
            return { status: parameters.OUTDATED_APP_VERSION, payload };
        }
        return { status: parameters.OK_APP_VERSION, payload };
    },
}